angular.module('lwNamb').factory('date', [
  function() {
    return {
      date: function() {
        return new Date();
      },
    };
  },
]);
